<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-bi">Acknowledgments</span></p>
<p class="tni">It was Orson Scott Card who first introduced me to Andreas Eschbach’s books, and then to Andreas himself. I was delighted to find that I not only enjoyed reading the novels and short stories, but that I liked Andreas very much as well: he is a man of charm and intelligence. So I am grateful to Scott for that introduction, and also for the years of friendship that he and Kristine have extended to my family and to me.</p>
<p class="tx">Das Europäische Übersetzer-Kollegium in Straelen, Germany, also deserves my special gratitude. I spent very productive weeks there while working on <span class="epub-i">The Carpet Makers.</span> Their reference library is superb, but the real pleasure of working there is the interaction with the staff and with the ever-changing coterie of other translators. I have seldom been in the company of more literate, intelligent, and helpful colleagues and friends.</p>
<p class="txs">Of course, I am always thankful to my four daughters—J.R., Emily, Kathryn, and Amanda—for their support and love, for their occasional reading of my translated texts, and for their willingness to offer insightful suggestions.</p>
<p class="tni">Doryl Jensen</p>
<p class="tni">Greensboro, NC</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?c9ebd096